import mitt from 'mitt'

const emitter = mitt()

export const events = {
  API_ERROR: 'apiError',
  API_SUCCESS: 'apiSuccess',
  API_WRONG_TOKEN: 'apiWrongToken',
  AXIOS_ERROR: 'axiosError',
}

export default emitter
